<style lang="scss">
.donut-chart {
  max-width: 100%;

  @media only screen and (min-width: 960px) and (max-width: 1264px) {
    max-width: 85%;
  }

  @media only screen and (min-width: 1264px) and (max-width: 1904px) {
    max-width: 75%;
  }

  @media only screen and (min-width: 1904px) {
    max-width: 50%;
  }
}
</style>

<template>
  <div class="donut-chart mx-auto">
    <h1
      class="my-4 grey--text text--darken-1  display-1 font-weight-bold  text-xs-center"
    >
      {{ title }}
    </h1>
    <apexchart type="donut" :options="chartOptions" :series="series" />
  </div>
</template>

<script>
export default {
  name: 'DonutChart',
  props: {
    title: {
      type: String,
      default: '',
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    series() {
      return this.data.map(e => e.count)
    },
    labels() {
      return this.data.map(e => e.name)
    },
    chartOptions() {
      return {
        width: '100%',
        intersect: false,
        legend: {
          position: 'bottom',
          fontSize: '18px',
          itemMargin: {
            vertical: 20,
          },
          markers: {
            width: 18,
            height: 18,
            radius: 18,
          },
        },
        theme: {
          mode: 'light',
        },
        colors: ['#008ffb', '#bdbdbd'],
        labels: this.labels,
        dataLabels: {
          formatter(val) {
            return Number.parseInt(val.toFixed(1), 10) + '%'
          },
          style: { fontSize: '24px' },
        },
        tooltip: {
          theme: 'dark',
          custom: this.genTooltipContent,
        },
        /* responsive: [
          {
            breakpoint: 769,
            options: {
              dataLabels: {
                style: { fontSize: '14px' },
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ], */
      }
    },
  },
  methods: {
    simple(count) {
      return `
        <div class="chart__tips">
          <h2 class="my-2headline">大腸鏡總筆數：${count} 筆</h2>
        </div>`
    },
    detail(count, items) {
      return `
        <div class="chart__tips">
          <h2 class="mb-3 headline">大腸鏡總筆數：${count} 筆</h2>
          <ul>
            ${items
              .map(
                e =>
                  `<li class="chart__tip">${e.name}: ${
                    e.count
                  } <span class="chart__percent">(${e.percent}%)</span></li>`,
              )
              .join('')}
          </ul>
        </div>`
    },
    genTooltipContent({ seriesIndex }) {
      const { count, subItems } = this.data[seriesIndex]
      return subItems ? this.detail(count, subItems) : this.simple(count)
    },
  },
}
</script>
